import { createStructuredSelector } from 'reselect';
import {
  SUP_EMPLOYEE_LIST, SUP_EMPLOYEE_LIST_SUCCESS, SUP_EMPLOYEE_LIST_ERROR,
  SUP_EMPLOYEE_PAGE_SET,
  SUP_EMPLOYEE_ADD, SUP_EMPLOYEE_ADD_SUCCESS, SUP_EMPLOYEE_ADD_ERROR,
  SUP_EMPLOYEE_ADD_CHANGE,
  SUP_EMPLOYEE_DETAIL, SUP_EMPLOYEE_DETAIL_SUCCESS, SUP_EMPLOYEE_DETAIL_ERROR,
  SUP_EMPLOYEE_UPDATE, SUP_EMPLOYEE_UPDATE_SUCCESS, SUP_EMPLOYEE_UPDATE_ERROR,
  SUP_EMPLOYEE_FILTER_SUPPLIERS, SUP_EMPLOYEE_FILTER_SUPPLIERS_SUCCESS,
} from '../../actions';

export const NAME = 'sup_employee';

export const SupplierEmployeeList = (page, num_page, orderBy, filters) => ({ type: SUP_EMPLOYEE_LIST, payload: { page, num_page, orderBy, filters } });
export const SupplierEmployeeListSuccess = (data) => ({ type: SUP_EMPLOYEE_LIST_SUCCESS, payload: data });
export const SupplierEmployeeListError = (error) => ({ type: SUP_EMPLOYEE_LIST_ERROR, payload: error });
export const SupplierEmployeePageSet = (data) => ({ type: SUP_EMPLOYEE_PAGE_SET, payload: data });
export const SupplierEmployeeAddChangeSet = (data) => ({ type: SUP_EMPLOYEE_ADD_CHANGE, payload: data });
export const SupplierEmployeeAdd = (data) => ({ type: SUP_EMPLOYEE_ADD, payload: data });
export const SupplierEmployeeAddSuccess = (message) => ({ type: SUP_EMPLOYEE_ADD_SUCCESS, payload: message });
export const SupplierEmployeeAddError = (error) => ({ type: SUP_EMPLOYEE_ADD_ERROR, payload: error });
export const SupplierEmployeeDetail = (data) => ({ type: SUP_EMPLOYEE_DETAIL, payload: data });
export const SupplierEmployeeDetailSuccess = (data) => ({ type: SUP_EMPLOYEE_DETAIL_SUCCESS, payload: data });
export const SupplierEmployeeDetailError = (error) => ({ type: SUP_EMPLOYEE_DETAIL_ERROR, payload: error });
export const SupplierEmployeeUpdate = (data) => ({ type: SUP_EMPLOYEE_UPDATE, payload: data });
export const SupplierEmployeeUpdateSuccess = (message) => ({ type: SUP_EMPLOYEE_UPDATE_SUCCESS, payload: message.message });
export const SupplierEmployeeUpdateError = (error) => ({ type: SUP_EMPLOYEE_UPDATE_ERROR, payload: error });
export const SupplierEmployeeFilterSuppliers = () => ({ type: SUP_EMPLOYEE_FILTER_SUPPLIERS });
export const SupplierEmployeeFilterSuppliersSuccess = (data) => ({ type: SUP_EMPLOYEE_FILTER_SUPPLIERS_SUCCESS, payload: data });

const sup_employee = (state) => state[NAME];
export const SupplierEmployeeSelector = createStructuredSelector({ sup_employee });
